import { faInfoCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ListarIconsFontAwesomeController } from "../../../../Controllers/Utils/FontAwesome/FontAwesomeControllers";
import { useSearch } from "../../../../hooks/useSearch";
import { useTransformToRef } from "../../../../hooks/useTransformToRef";
import { IFontAwesomeIconLookup } from "../../../../Interfaces/Utils/FontAwesome";
import OrSpinner from "../../../Utils/OrSpinner";

import "./styles.css";

interface IIconSelectorProps {
    onChange?: (value: string) => void;
    defaultValue?: string;
    color?: `#${string}`;
}

export default function IconSelector(props: IIconSelectorProps) {
    const { onChange, color } = props;
    const onChangeRef = useTransformToRef(onChange);

    const [selectedIcon, setSelectedIcon] = useState(props.defaultValue);
    const {
        handleSearch: buscarIcones,
        loading,
        value: lstIconsFontAwesome,
    } = useSearch(ListarIconsFontAwesomeController, {
        noLimit: true,
        cache: true,
        inicial: "",
    });

    useEffect(() => {
        onChangeRef.current?.(selectedIcon ?? "");
    }, [selectedIcon, onChangeRef]);

    return (
        <div className="row w-100 m-0 my-4">
            <div className="col-3 col-sm-2 col-lg-1">
                <div className="selected-icon h-100 w-100">
                    <i
                        className={`${selectedIcon}`}
                        style={props.color ? { color } : undefined}
                    />
                </div>
            </div>
            <div className="col-9 col-sm-10 col-lg-11">
                <div className="input-group w-100">
                    <div className="input-group-prepend">
                        <span className="input-group-text text-secondary">
                            <FontAwesomeIcon icon={faSearch} />
                        </span>
                    </div>
                    <input
                        onChange={(e) => buscarIcones(e.target.value)}
                        className="form-control"
                        aria-describedby="pesquisa de ícone"
                    />
                    <div className="input-group-append">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="english-search-info">
                                    As buscas por ícones devem ser feitas com
                                    palavras-chave em inglês
                                </Tooltip>
                            }
                        >
                            <span className="input-group-text text-secondary">
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </span>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-center align-items-center my-4">
                <OrSpinner loading={loading} loadingColor="primary">
                    <div className="col-12 d-flex flex-wrap w-100 align">
                        {lstIconsFontAwesome?.map((i) => (
                            <Icon
                                {...i}
                                onSelect={setSelectedIcon}
                                selected={
                                    `${i.prefix} fa-${i.iconName}` ===
                                    selectedIcon
                                }
                                selectedColor={color}
                                key={`${i.prefix}-${i.iconName}`}
                            />
                        ))}
                    </div>
                </OrSpinner>
            </div>
        </div>
    );
}

function Icon(
    props: IFontAwesomeIconLookup & {
        selected: boolean;
        onSelect: (iconClass: string) => void;
        selectedColor?: string;
    }
) {
    const { selected, onSelect, selectedColor, ...icon } = props;

    return (
        <div
            title={icon.label}
            className={`icon-to-select-div  ${
                selected && !selectedColor ? "selected" : ""
            }`}
            onClick={() => onSelect(`${icon.prefix} fa-${icon.iconName}`)}
        >
            <i
                className={`${icon.prefix} fa-${icon.iconName}`}
                style={
                    selectedColor && selected
                        ? { color: selectedColor }
                        : undefined
                }
            />
        </div>
    );
}
